// The About Page JS
window.Page = {

    // We need to grab a few components
    buttons  : document.querySelectorAll('.person-button'),
    template : document.querySelector("#person-overlay"),

    // The cards also need an overlay
    cardsButtons  : document.querySelectorAll('.about-card-button'),
    cardsTemplate : document.querySelector("#about-card-overlay"),

    // Init Function
    liftoff : () => {
        Page.createOverlay()
        Page.createCardOverlay()
    },

    // Create an overlay
    createOverlay : () => {
        Page.buttons.forEach(button => {
            button.addEventListener('click' , () => {

                // First we need to clone the overlay
                const overlay = Page.template.content.cloneNode(true);

                // We need first need to grab the various components
                let wrap   = overlay.querySelector('.person-overlay-content');
                let avatar = overlay.querySelector('.person-overlay-image');
                let title  = overlay.querySelector('.person-overlay-name');
                let bio    = overlay.querySelector('.person-overlay-bio');
                let close  = overlay.querySelector('.person-overlay-button');
                let prev   = overlay.querySelector('.person-overlay-prev');
                let next   = overlay.querySelector('.person-overlay-next');

                // Then we can grab the content
                let avatarContent = button.parentNode.querySelector('.person-portrait');
                let titleContent  = button.parentNode.querySelector('.person-name');
                let textContent   = button.parentNode.querySelector('.person-long-bio');

                // Attach the close event
                close.addEventListener('click' , () => {
                    document.querySelector('.person-overlay').remove()
                })
                
                prev.addEventListener('click' , () => {

                    // Remove the current overlay
                    document.querySelector('.person-overlay').remove()

                    // Grab the previous element
                    let prevTarget = button.parentElement.previousElementSibling;

                    // Check and grab the correct element if the previous items is not a person
                    if (!prevTarget.classList.contains('person'))
                        prevTarget = prevTarget.parentElement.lastElementChild;

                    prevTarget.querySelector('.person-button').click();


                })
                next.addEventListener('click' , () => {

                    // remove the current overlay
                    document.querySelector('.person-overlay').remove()

                    // grab the next target
                    let nextTarget = button.parentElement.nextElementSibling

                    if (!nextTarget)
                        nextTarget = button.parentElement.parentElement.querySelector('article');

                    nextTarget.querySelector('.person-button').click();

                })

                // And now we can update the content
                avatar.setAttribute('src' , avatarContent.getAttribute('src'))
                title.innerHTML = titleContent.innerHTML;
                bio.innerHTML   = textContent.innerHTML;
                wrap.style.background = `var(${button.value})`

                // We need to add the background color


                // Now we can append the new overlay to the body
                document.body.appendChild(overlay)

            })
        })
    },

    // Create an overlay for the cards
    createCardOverlay : () => {
        Page.cardsButtons.forEach(button => {
            button.addEventListener('click' , () => {

                // First we need to clone the overlay
                const overlay = Page.cardsTemplate.content.cloneNode(true);

                // We need first need to grab the various components
                let image  = overlay.querySelector('.about-card-overlay-image');
                let title  = overlay.querySelector('.about-card-overlay-title');
                let text   = overlay.querySelector('.about-card-overlay-text');
                let close  = overlay.querySelector('.about-card-overlay-button');
                let prev   = overlay.querySelector('.about-card-overlay-prev');
                let next   = overlay.querySelector('.about-card-overlay-next');

                // Then we can grab the content
                let imageContent  = button.parentNode.parentNode.querySelector('.about-card-image');
                let titleContent  = button.parentNode.querySelector('.about-card-title');
                let textContent   = button.parentNode.querySelector('.about-card-text');

                // Attach the close event
                close.addEventListener('click' , () => {
                    document.querySelector('.about-card-overlay').remove()
                })
                
                prev.addEventListener('click' , () => {

                    // Remove the current overlay
                    document.querySelector('.about-card-overlay').remove()

                    // Grab the previous element
                    let prevTarget = button.parentElement.parentElement.previousElementSibling;

                    // Check and grab the correct element if the previous items is not a person
                    if (!prevTarget)
                        prevTarget = button.parentElement.parentElement.parentElement.lastElementChild;

                    prevTarget.querySelector('.about-card-button').click();


                })
                next.addEventListener('click' , () => {

                    // remove the current overlay
                    document.querySelector('.about-card-overlay').remove()

                    // grab the next target
                    let nextTarget = button.parentElement.parentElement.nextElementSibling

                    if (!nextTarget)
                        nextTarget = button.parentElement.parentElement.parentElement.firstElementChild;

                    nextTarget.querySelector('.about-card-button').click();

                })

                // And now we can update the content
                image.setAttribute('src' , imageContent.dataset.src)
                title.innerHTML = titleContent.innerHTML;
                text.innerHTML   = textContent.innerHTML;

                // Now we can append the new overlay to the body
                document.body.appendChild(overlay)

            })
        })
    }



}

// Launch The Script
Page.liftoff()
